// IMPORTANT NOTE:
// Labels should also be doubled as comments in order for the i18n-parser to intercept them
// t('languages.English', { ns: 'common' });
// t('languages.German', { ns: 'common' });
// t('languages.Spanish', { ns: 'common' });
// t('languages.French', { ns: 'common' });
// t('languages.Japanese', { ns: 'common' });
// t('languages.Korean', { ns: 'common' });
// t('languages.Russian', { ns: 'common' });
// t('languages.Chinese, simplified', { ns: 'common' });

export default [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'ja', label: 'Japanese' },
  { value: 'ko', label: 'Korean' },
  { value: 'ru', label: 'Russian' },
  { value: 'zh-hans', label: 'Chinese, simplified' },
];
